/**
 * Theme v2 — spacing tokens.
 *
 * 4px grid. Components consume by semantic step (`spacing.md`) not by
 * pixel value, so retuning the grid later is one-file work.
 *
 * AntD's defaults (padding: 16, paddingLG: 24, paddingXL: 32, margin:
 * 16, marginLG: 24) all map onto entries in this scale — see
 * `libertify-theme-v2.ts` for the AntD wiring.
 */
export const spacing = {
  none: 0,
  xs: 4, // 1× grid
  sm: 8, // 2×
  md: 12, // 3×
  base: 16, // 4× — AntD's `padding` / `margin` default
  lg: 24, // 6× — AntD's `paddingLG` / `marginLG`
  xl: 32, // 8× — AntD's `paddingXL`
  "2xl": 48,
  "3xl": 64,
  "4xl": 96,
} as const;

export type Spacing = typeof spacing;
